import React from 'react';
import { useTenant } from '../../../context/TenantContext';
import { parseEm } from '../inlineEm';
import { CREDITS } from './content';
import { REVISE_ANCHORS } from './sectionMeta';

/**
 * "Who made this" — deliberately prose rather than the `instructor` person
 * card the other themes use. The credibility here is collective (teachers,
 * examiners, trainers) and a single headshot would misrepresent it.
 */
export const ReviseCredits: React.FC = () => {
  const { tenant } = useTenant();
  const credits = tenant?.branding.marketing?.credits;

  const eyebrow = credits?.eyebrow || CREDITS.eyebrow;
  const heading = credits?.heading || CREDITS.heading || '';
  const paragraphs = credits?.paragraphs?.length ? credits.paragraphs : CREDITS.paragraphs;

  if (paragraphs.length === 0) return null;

  /* `essay` (pink), not the study gold this section used to borrow. It is about
     the people rather than about a lab, so the lab accents had nothing to say
     here — and gold on this page means "this one is free", which is not what a
     credential is. */
  return (
    <section className="rv-sec rv-band-centre" id={REVISE_ANCHORS.credits} data-accent="essay">
      <div className="rv-wrap">
        <div className="rv-head">
          {eyebrow && <p className="rv-kicker">{eyebrow}</p>}
          {heading && <h2>{parseEm(heading)}</h2>}
        </div>
        <div className="rv-creds">
          {paragraphs.map((para) => (
            <p className="rv-p" key={para.slice(0, 40)}>
              {para}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};
